import { createSlice } from '@reduxjs/toolkit';
import apiClient from './apiClient';
import { toGraphQLQuery } from "./graphQLHelpers.js";

const initialState = {
  all: []
};

const REQUESTS = {
  index: ({projectId}, outputFields = `id`) => {
    return `query {
      orthophotos(
        projectId: "${projectId}"
      ) {
        ${outputFields}
      }
    }`;
  },
  create: ({projectId, path_prefix, partCount}, outputFields) => `
    mutation {
      createOrthophoto(orthophoto: {
        path_prefix: "${path_prefix}",
        projectId: "${projectId}",
        partCount: ${partCount}
      }) {
        ${outputFields}
      }
    }
  `,
  updateOrthophotoStatus: ({id, status, uploadId, parts}, outputFields) => `
    mutation {
      updateOrthophotoStatus(orthophoto: {
        id: "${id}",
        status: ${status},
        uploadId: "${uploadId}"
        parts: ${toGraphQLQuery(parts)}
      }) {
        ${outputFields}
      }
    }
  `,
}


export const orthophotosSlice = createSlice({
  name: 'orthophotos',
  initialState,
  reducers: {
    setOrthophotos: (state, { payload: { orthophotos } }) => {
      return {
        ...state,
        all: orthophotos
      };
    },
  }
});

export const { setOrthophotos } = orthophotosSlice.actions;

export const orthophotosApi = {
  index: async ({projectId}, outputFields, next) => {
    const result = await apiClient.req(REQUESTS.index({projectId}, outputFields));
    if (result.data.errors != null) throw new Error("An error occured: " + JSON.stringify(result.data.errors));
    return result.data.data.orthophotos;
  },
  create: async ({projectId, path_prefix, partCount}, outputFields, next) => {
    const result = await apiClient.req(REQUESTS.create({projectId, path_prefix, partCount}, outputFields));
    if (result.data.errors != null) throw new Error("An error occured: " + JSON.stringify(result.data.errors));
    return result.data.data.createOrthophoto;
  },
  updateOrthophotoStatus: async ({id, status, path_prefix, uploadId, parts}, outputFields, next) => {
    const result = await apiClient.req(REQUESTS.updateOrthophotoStatus({id, path_prefix, status, uploadId, parts}, outputFields));
    if (result.data.errors != null) throw new Error("An error occured: " + JSON.stringify(result.data.errors));
    return result.data.data.updateOrthophotoStatus;
  },
};

export const selectOrthophotos = (state) => state.orthophotos.all;

export default orthophotosSlice.reducer;